import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantEffects } from './tenant.effects';
import * as fromTenant from './tenant.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TenantApiService } from './tenant.api.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TenantService } from './tenant.service';
import { InfoStoreModule } from '../info-store/info-store.module';
import { AuthHttpInterceptor } from '../session-store/auth-http.interceptor.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromTenant.tenantFeatureKey, fromTenant.reducer),
    EffectsModule.forFeature([TenantEffects]),
    InfoStoreModule,
  ],
  providers: [
    TenantApiService,
    TenantService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class TenantStoreModule {}
